import React from 'react'
import { useNavigate } from 'react-router-dom'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      selectDate // via withState
    } = props

    const navigate = useNavigate()

    const handleChangeDate = date => {
      selectDate(date)
      if (date && date.isValid()) {
        navigate(`?date=${date.format('YYYY-MM-DD')}`)
      }
    }

    return <WrappedComponent onChangeDate={handleChangeDate} {...props} />
  }
}

export default withEventHandlers
